import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createHistory } from 'history';

import {
  updateLocationState,
  clearLocationRequest,
  clearAllCollectives,
  requestLocationChange
} from '../actions';

// Views
import Home from '../containers/Home';
import Login from '../containers/Login';
import Users from '../containers/Users';
import Search from '../containers/Search';
import NewCollective from '../containers/NewCollective';
import NewInfluencer from '../containers/NewInfluencer';
import EditInfluencer from '../containers/EditInfluencer';
import EditCollective from '../containers/EditCollective';
import ViewInfluencer from '../containers/ViewInfluencer';
import ViewCollective from '../containers/ViewCollective';
import Importer from '../containers/Importer';
import LoadingOverlay from '../components/LoadingOverlay';

const history = createHistory();

export const hasAccess = (currentUser, locationName) => {
  const adminOnly = [
    'userEdit',
    'editCollectiveImport',
    'importInfluencers',
  ];

  if (currentUser && currentUser.get('admin')) return true;

  // For non-admin
  return adminOnly.indexOf(locationName) === -1;
};

class Router extends Component {

  componentWillMount() {
    const { dispatch } = this.props;
    this.historyUnlisten = history.listen(function (location) {
      dispatch(updateLocationState(location));
    });
  }

  componentWillReceiveProps(newProps) {
    if (newProps.currentUser.get('id') && !hasAccess(newProps.currentUser, newProps.location.get('name'))) {
      this.redirectToSearch();
    }

    if (
      this.props.location.get('request').get('pathname')
      !== newProps.location.get('request').get('pathname')
      && newProps.location.get('request').get('pathname')
      ) {
      history.push({
        pathname: newProps.location.get('request').get('pathname'),
        search: newProps.location.get('request').get('search'),
      });
      this.props.dispatch(clearLocationRequest());
    }
  }

  componentWillUnmount() {
    this.historyUnlisten();
  }

  onLocationChange = () => this.props.dispatch(updateLocationState());

  redirectToSearch = () => this.props.dispatch(requestLocationChange('search'));

  render() {
    const { location, dispatch } = this.props;

    switch (location.get('name')) {
      case 'home':
        return <Home options={location.get('options')} />;
      case 'login':
        return <Login options={location.get('options')} />;
      case 'search':
        return <Search options={location.get('options')} />;
      case 'userIndex':
      case 'userEdit':
        return <Users options={location.get('options')} />;
      case 'collectiveViewInfluencer':
      case 'viewInfluencer':
        return <ViewInfluencer options={location.get('options')} />;
      case 'influencerViewCollective':
      case 'viewCollective':
        return <ViewCollective options={location.get('options')} />;
      case 'newCollective':
        return <NewCollective options={location.get('options')} />;
      case 'newInfluencer':
        return <NewInfluencer options={location.get('options')} />;
      case 'editCollective':
      case 'editCollectiveImport':
        return <EditCollective options={location.get('options')} />;
      case 'editInfluencer':
        return <EditInfluencer options={location.get('options')} />;
      case 'importInfluencers':
        return <Importer options={location.get('options')} />;
    }

    // return <LoadingOverlay loading={true} />;
    return <div></div>;
  }
}

function mapStateToProps(state) {
  return {
    location: state.get('location'),
    currentUser: state.get('currentUser'),
  };
};

export default connect(mapStateToProps)(Router);



/** WEBPACK FOOTER **
 ** ./containers/Router.js
 **/